// Module
var code = "<div class=\"basket-ui-messages\"> </div>";
// Exports
module.exports = code;